export default __webpack_public_path__ + "static/images/2de407a5c424e04a957ecaf6f3919766.png";